module.exports = __webpack_public_path__ + "static/img/Jasper-Catton.b967904.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jasper-Catton.jpg
// module id = 8TSq
// module chunks = 0